(function() {
    'use strict';
    var toggles = document.querySelectorAll('.sub-nav-toggle');

    Array.prototype.forEach.call(toggles, function (toggle) {
        var id = toggle.getAttribute('id');
        var menu = document.getElementById('menu-' + id);

        toggle.changeMenuState = function (state) {
            menu.hidden = state;
        }
        toggle.changeMenuText = function (state) {
            var menuText = state !== false ? 'Open Menu' : 'Close Menu'
            return this.querySelector('span').textContent = menuText;
        }
        toggle.onclick = function () {
            var expanded = this.getAttribute('aria-expanded') === 'true' || false;
            this.setAttribute('aria-expanded', !expanded);

            this.changeMenuState(expanded);
            this.changeMenuText(expanded);

        }
        toggle.onkeydown = function(e){
            //console.log(e);
        }
    });
})();